export const MODE = import.meta.env.MODE;

export const MONITORING_CONNECTION_STRING = import.meta.env.VITE_MONITORING_CONNECTION_STRING;
export const MONITORING_ENVIRONMENT = import.meta.env.VITE_MONITORING_ENVIRONMENT;

export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID;
export const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE;
export const AUTH0_SCOPE = 'openid profile email offline_access full';

export const SCANDIT_LICENSE_KEY = import.meta.env.VITE_SCANDIT_LICENSE_KEY;

export const IMGIX_STATIC_BASE_URL = import.meta.env.VITE_IMGIX_STATIC_BASE_URL;
export const IMGIX_DYNAMIC_BASE_URL = import.meta.env.VITE_IMGIX_DYNAMIC_BASE_URL;

export const RELEASE_NAME = import.meta.env.RELEASE_NAME;

export const IGP_WEBSITE_URL = 'https://igp-powder.com';
export const DOLD_GROUP_WEBSITE_URL = 'https://doldgroup.com';

export const DOCUMENT_TITLE_SUFFIX = 'IGP';

export const PAGE_HEADER_IMG_URL_DESKTOP = `${IMGIX_STATIC_BASE_URL}/header-keyvisual-desktop.jpg`;
export const PAGE_HEADER_IMG_URL_MOBILE = `${IMGIX_STATIC_BASE_URL}/header-keyvisual-mobile.jpg`;

export const WEBSITE_ID = import.meta.env.VITE_UMAMI_WEBSITE_ID === '' ? null : import.meta.env.VITE_UMAMI_WEBSITE_ID;
